import { P, canManageRole, type RoleLike } from '@tasca/shared';
import type { Guild, Member, Role } from '@tasca/client-sdk';

/**
 * O utilizador pode isto?
 *
 * O bitfield chega como string porque não cabe num `number` — são 64 bits.
 * `ADMINISTRATOR` passa por cima de tudo, como no servidor; se as duas
 * respostas divergissem, a UI oferecia botões que a API recusa (ou escondia
 * os que aceita), que é das poucas formas de uma interface mentir sozinha.
 *
 * Isto decide o que se MOSTRA. Quem decide o que se FAZ é a API, sempre.
 */
export function has(permissions: string | undefined, bit: bigint): boolean {
  if (!permissions) return false;
  try {
    const value = BigInt(permissions);
    return (value & P.ADMINISTRATOR) !== 0n || (value & bit) === bit;
  } catch {
    return false;
  }
}

/**
 * Este grupo pode ser dado ou tirado por quem está a olhar?
 *
 * A regra é a MESMA do servidor — `canManageRole` vem de @tasca/shared, não é
 * reescrita aqui: uma segunda implementação da hierarquia divergia da
 * primeira ao primeiro ajuste, e o sintoma seria uma caixa que se pode marcar
 * e volta atrás sozinha. O que isto decide é o que se MOSTRA; quem decide o
 * que acontece continua a ser a API.
 */
export function canAssignRole(
  guild: Guild,
  actor: Member | undefined,
  role: Role,
  roles: Role[],
): boolean {
  if (!actor) return false;
  // Em try/catch pela mesma razão que o `has`: os ids e os bitfields chegam
  // como texto, e um valor estranho não pode derrubar o ecrã inteiro — o pior
  // que deve acontecer é a caixa ficar por marcar.
  try {
    const map = new Map<bigint, RoleLike>(
      roles.map((r) => [BigInt(r.id), { permissions: BigInt(r.permissions), position: r.position }]),
    );
    return canManageRole(
      { id: BigInt(guild.id), ownerId: BigInt(guild.ownerId) },
      { userId: BigInt(actor.userId), roleIds: actor.roles.map((r) => BigInt(r)) },
      { permissions: BigInt(role.permissions), position: role.position },
      map,
    );
  } catch {
    return false;
  }
}
